/**
 * i18next backend that loads JSON per (language, namespace) via registered dynamic importers.
 * Keeps each Vite app’s loaders in a Map scoped to the i18next instance.
 */
export function createResourceBackend(namespaceLoaders, { fallbackLng = 'en' } = {}) {
  return {
    type: 'backend',
    init() {},
    read(language, namespace, callback) {
      const loaders = namespaceLoaders.get(namespace);
      if (!loaders) {
        callback(null, false);
        return;
      }
      const tryLng = (lng) => loaders[lng];
      const importer = tryLng(language) || tryLng(fallbackLng) || loaders.en;
      if (!importer) {
        callback(null, false);
        return;
      }
      Promise.resolve(importer())
        .then((mod) => {
          const data = mod?.default ?? mod;
          callback(null, data);
        })
        .catch((err) => callback(err, false));
    },
  };
}
